import { createLocalStorageRecentSearchesPlugin, search } from "@algolia/autocomplete-plugin-recent-searches";
import { useLanguages } from "@/core/composables";
import { prefixLocaleUrl } from "@/core/utilities";

export function createRecentSearchesPluginInstance() {
  const { currentLocale, defaultLocale } = useLanguages();

  return createLocalStorageRecentSearchesPlugin({
    key: "autocomplete-two-column-layout-example",
    search(params) {
      return search({ ...params, limit: 5 });
    },
    transformSource({ source }) {
      return {
        ...source,
        templates: {
          ...source.templates,
          item({ html, item }) {
            return html`
              <div class="aa-Item" style="cursor: pointer;">
                <a
                  href="${prefixLocaleUrl(`/search?q=${item.label}`, currentLocale.value, defaultLocale.value)}"
                  onClick=${() => {
                    // Dispatch a custom DOM event to close the search dropdown
                    const event = new CustomEvent("closeSearchDropdown");
                    document.dispatchEvent(event);
                  }}
                >
                  <span class="aa-ItemContent">
                    <svg class="vc-icon shrink-0">
                      <use href="/static/thorlabs/icons/basic/arrow-rotate-right.svg?#icon"></use>
                    </svg>
                    <span> ${item.label} </span></span
                  >
                </a>
              </div>
            `;
          },
        },
      };
    },
  });
}
